/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "@common/AggregationComponent";
import { isEmpty } from "lodash";

const ProductTabCategoryFilter = (props: any) => {
  const { tree, categoryType, selectedCategories, onChangeSelectedCategories } =
    props;

  const [filteredCategories, setFilteredCategories] = useState<any[]>([]);
  const [isShowGenderSelect, setIsShowGenderSelect] = useState<boolean>(false);
  const [isShowClassSelect, setIsShowClassSelect] = useState<boolean>(false);
  const [isShowCategorySelect, setIsShowCategorySelect] =
    useState<boolean>(false);
  const [isShowSubcategorySelect, setIsShowSubcategorySelect] =
    useState<boolean>(false);

  const { t } = useTranslation();

  // 刷新页面的时候重新初始化
  useEffect(() => {
    updateSearchCategoriesStatus();
  }, [tree]);

  useEffect(() => {
    if (
      (categoryType === "genders" ||
        categoryType === "classes" ||
        categoryType === "categories" ||
        categoryType === "subcategories" ||
        categoryType === "") &&
      getGenderOptions().length !== 0
    ) {
      setIsShowGenderSelect(true);
    } else {
      setIsShowGenderSelect(false);
    }
    if (
      (categoryType === "genders" ||
        categoryType === "classes" ||
        categoryType === "categories" ||
        categoryType === "subcategories" ||
        categoryType === "") &&
      getClassOptions().length !== 0
    ) {
      setIsShowClassSelect(true);
    } else {
      setIsShowClassSelect(false);
    }
    if (
      (categoryType === "categories" ||
        categoryType === "subcategories" ||
        categoryType === "") &&
      getCategoryOptions().length !== 0
    ) {
      setIsShowCategorySelect(true);
    } else {
      setIsShowCategorySelect(false);
    }
    if (
      (categoryType === "subcategories" || categoryType === "") &&
      getSubcategoryOptions().length !== 0
    ) {
      setIsShowSubcategorySelect(true);
    } else {
      setIsShowSubcategorySelect(false);
    }
  }, [categoryType, tree]);

  const updateSearchCategoriesStatus = () => {
    let newCategories = [];
    if (tree[categoryType] && tree[categoryType].length) {
      newCategories = tree[categoryType].map((item: any) => ({
        ...item,
        categoryType: categoryType
      }));
    }
    setFilteredCategories(newCategories);
  };

  const handleAddCategoryType = () => {
    const hasCategoryTypeTree: any = tree;
    const tempArr: any = [];
    const res: any = [];
    if (hasCategoryTypeTree?.genders?.length > 0) {
      hasCategoryTypeTree.genders.map((gender: any) => {
        tempArr.push({ ...gender, categoryType: "genders" });
      });
    }
    if (hasCategoryTypeTree?.classes?.length > 0) {
      hasCategoryTypeTree.classes.map((_class: any) => {
        tempArr.push({ ..._class, categoryType: "classes" });
      });
    }
    if (hasCategoryTypeTree?.categories?.length > 0) {
      hasCategoryTypeTree.categories.map((category: any) => {
        tempArr.push({ ...category, categoryType: "categories" });
      });
    }
    if (hasCategoryTypeTree?.subcategories?.length > 0) {
      hasCategoryTypeTree.subcategories.map((subcategory: any) => {
        tempArr.push({ ...subcategory, categoryType: "subcategories" });
      });
    }
    if (selectedCategories.length !== 0) {
      selectedCategories.map((itemOne: any) => {
        res.push(tempArr.find((itemTwo: any) => itemTwo.id === itemOne.id));
      });
    }
    return res;
  };

  const handlerCategoryClick = (value: any, type: string) => {
    const _index = handleAddCategoryType().findIndex(
      (item: any) => item.categoryType === type
    );
    if (value === "") {
      //if click "All" option
      if (_index !== -1) {
        //the option that user click is not the current choosen option
        const _res = JSON.parse(JSON.stringify(selectedCategories)).splice(
          0,
          _index
        );
        onChangeSelectedCategories(_res);
      }
    } else {
      if (
        selectedCategories.filter((item: any) => {
          item.id === value;
        }).length === 0
      ) {
        //the option that user click is not the current choosen option
        if (_index !== -1) {
          //if this hierarchy has been choosen before
          const _newRes = {
            ...tree[type].find((_class: any) => _class.id === value),
            categoryType: type
          };
          const _res = JSON.parse(JSON.stringify(selectedCategories)).splice(
            0,
            _index
          );
          _res.push(_newRes);
          onChangeSelectedCategories(_res);
        } else {
          const res: any = filteredCategories.filter(
            (classOption: any) => classOption.id === value
          );
          onChangeSelectedCategories([...selectedCategories, ...res]);
        }
      }
    }
  };

  const getGenderOptions = () => {
    if (!isEmpty(tree)) {
      return tree.genders.map((item: any) => ({
        label: item.name,
        value: item.id
      }));
    }
    return [];
  };

  const getClassOptions = () => {
    if (!isEmpty(tree)) {
      return tree.classes.map((item: any) => ({
        label: item.name,
        value: item.id
      }));
    }
    return [];
  };

  const getCategoryOptions = () => {
    if (!isEmpty(tree)) {
      return tree.categories.map((item: any) => ({
        label: item.name,
        value: item.id
      }));
    }
    return [];
  };

  const getSubcategoryOptions = () => {
    if (!isEmpty(tree)) {
      return tree.subcategories.map((item: any) => ({
        label: item.name,
        value: item.id
      }));
    }
    return [];
  };
  return (
    <>
      <div>
        {isShowGenderSelect && (
          <Dropdown
            id="selectGender"
            name="genderOptions"
            className="fr-ec-mb-spacing-06"
            label={t("text_gender")}
            placeholder={t("text_all")}
            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
              e.preventDefault();
            }}
            onChange={(_: any, value: any) => {
              handlerCategoryClick(
                value === "" ? value : JSON.parse(value),
                "genders"
              );
            }}
            isNative
            value={
              props.searchCategories[0]
                ? JSON.parse(props.searchCategories[0])
                : undefined
            }
            options={getGenderOptions()}
            disabled={false}
          />
        )}
        {isShowClassSelect && (
          <Dropdown
            id="selectClass"
            name="classOptions"
            className="fr-ec-mb-spacing-05"
            label={t("text_category")}
            placeholder={
              categoryType === "genders"
                ? t("text_search_filter_select_category_message_01")
                : t("text_all")
            }
            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
              e.preventDefault();
            }}
            onChange={(_: any, value: any) => {
              handlerCategoryClick(
                value === "" ? value : JSON.parse(value),
                "classes"
              );
            }}
            isNative
            value={
              props.searchCategories[1]
                ? JSON.parse(props.searchCategories[1])
                : undefined
            }
            options={getClassOptions()}
            disabled={categoryType === "genders"}
          />
        )}
        {isShowCategorySelect && (
          <Dropdown
            id="selectCategory"
            name="categoryOptions"
            className="fr-ec-mb-spacing-05"
            placeholder={t("text_all")}
            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
              e.preventDefault();
            }}
            onChange={(_: any, value: any) => {
              handlerCategoryClick(
                value === "" ? value : JSON.parse(value),
                "categories"
              );
            }}
            isNative
            value={
              props.searchCategories[2]
                ? JSON.parse(props.searchCategories[2])
                : undefined
            }
            options={getCategoryOptions()}
            disabled={false}
          />
        )}
        {isShowSubcategorySelect && (
          <Dropdown
            id="selectSubcategory"
            name="subcategoryOptions"
            className="fr-ec-mb-spacing-05"
            placeholder={t("text_all")}
            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
              e.preventDefault();
            }}
            onChange={(_: any, value: any) => {
              handlerCategoryClick(
                value === "" ? value : JSON.parse(value),
                "subcategories"
              );
            }}
            isNative
            value={
              props.searchCategories[3]
                ? JSON.parse(props.searchCategories[3])
                : undefined
            }
            options={getSubcategoryOptions()}
            disabled={false}
          />
        )}
      </div>
    </>
  );
};
export default ProductTabCategoryFilter;
